import { createColumnHelper } from '@tanstack/react-table';
import { IItemGroupTableRow } from '@westondev/tableturn-core';

export const columnHelper = createColumnHelper<IItemGroupTableRow>();

export const ITEMS_TABLE_ID = 'main-screen-item-groups-table';
export const ROW_ID_PREFIX = 'mainScreen-item-groups-row-';
